/**
 * Domain Configuration
 * This file is auto-generated based on the DOMAIN_NAME environment variable
 * Used to replace {{DOMAIN_NAME}} placeholders in locale files
 * 
 * Generated at: 2026-01-29T17:52:53.270Z
 */

// Domain name from environment variable (set at build time)
export const DOMAIN_NAME = 'meet-milf-australia.de'

export default DOMAIN_NAME
